import { Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { BuilderSettings } from '../../redux/types/builders';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface DisclosureProps {
  formik: any;
  builderSettings: BuilderSettings;
}

export const Disclosure = ({ formik, builderSettings }: DisclosureProps) => {
  const { t: translate } = useTranslation();
  const companyName = builderSettings?.legal_name || builderSettings?.webflow_name || builderSettings?.builderName;

  const params = useParams<{ builder_name: string }>();
  const isDRHorton = params?.builder_name?.toLowerCase().includes('drhorton');

  useEffect(() => {
    const formikFieldActive = formik.getFieldProps('customDisclosureActive')?.value ?? false;

    if (builderSettings?.custom_disclosure_active && !formikFieldActive) {
      formik.setFieldValue('customDisclosureActive', true);
    }
  }, [builderSettings?.custom_disclosure_active, formik]);

  const defaultDisclosureModal = () => {
    Swal.fire({
      title: translate('visitor_access_agreement'),
      html: translate('visitor_access_agreement_body', {
        companyName,
        supportEmail: '<a href="mailto:support@nternow.com">support@nternow.com</a>',
      }),
      confirmButtonColor: builderSettings.primary_color,
      confirmButtonText: translate('accept'),
      showCancelButton: true,
    }).then(result => {
      if (result.isConfirmed) {
        formik.setFieldValue('privacyPolicy', true);
      }

      if (result.isDismissed) {
        formik.setFieldValue('privacyPolicy', false);
      }
    });
  };

  const customDisclosureModal = () => {
    Swal.fire({
      title: builderSettings.custom_disclosure_name,
      text: builderSettings.custom_disclosure_text,
      confirmButtonColor: builderSettings.primary_color,
      confirmButtonText: translate('accept'),
      showCancelButton: true,
    }).then(result => {
      if (result.isConfirmed) {
        formik.setFieldValue('customDisclosure', true);
      }

      if (result.isDismissed) {
        formik.setFieldValue('customDisclosure', false);
      }
    });
  };

  return (
    <Form.Group
      className={
        formik.errors.privacyPolicy || formik.errors.customDisclosure
          ? 'form-group form-group-checkbox mt-0 is-invalid'
          : 'form-group form-group-checkbox mt-0'
      }
    >
      <Form.Check
        type="checkbox"
        label={
          <small>
            {translate('disclosure_intro')}{' '}
            {!isDRHorton && (
              <span>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => {
                    defaultDisclosureModal();
                  }}
                >
                  {translate('visitor_access_agreement')}
                </button>
                {', '}
              </span>
            )}
            <a
              href="https://nternow.com/privacy-policy/"
              rel="noreferrer"
              target="_blank"
            >
              {translate('privacy_policy')}
            </a>{' '}
            {', '}
            <a
                href="https://nternow.com/biometric-notice-and-consent"
                rel="noreferrer"
                target="_blank"
            >
              {translate('biometric_policy')}
            </a>{' '}
            {translate('disclosure_and')}{' '}
            <a
              href="https://nternow.com/privacy-policy/"
              target="_blank"
              rel="noreferrer"
            >
              {translate('terms_of_service')}
            </a>
            .
          </small>
        }
        id="privacyPolicy"
        checked={formik.values.privacyPolicy}
        isInvalid={!!formik.errors.privacyPolicy}
        onChange={() =>
          formik.setFieldValue('privacyPolicy', !formik.values.privacyPolicy)
        }
      />
      {builderSettings?.custom_disclosure_active && (
        <Form.Check
          type="checkbox"
          label={
            <small>
              <button
                type="button"
                className="link-button"
                onClick={() => {
                  customDisclosureModal();
                }}
              >
                {builderSettings.custom_disclosure_name}
              </button>
              .
            </small>
          }
          id="customDisclosure"
          checked={formik.values.customDisclosure}
          isInvalid={!!formik.errors.customDisclosure}
          onChange={() =>
            formik.setFieldValue('customDisclosure', !formik.values.customDisclosure)
          }
        />
      )}
      <span className="invalid-feedback">
        {formik.errors.privacyPolicy || formik.errors.customDisclosure
          ? translate('accept_terms_error')
          : ''}
      </span>
    </Form.Group>
  )
}
